module.exports = __webpack_public_path__ + "media/application/images/2018/header-lock-3e164545f32963ffbffefd7ed1dd39c2.svg";